import { Link } from "react-router-dom";
import type { ChangeItem } from "@akhshy/types";
import { useAsync } from "../../lib/useAsync.ts";
import { client } from "../../lib/api.ts";

function itemPath(i: ChangeItem): string {
  switch (i.entryType) {
    case "vault":
      return `/vault/${i.slug ?? i.entryId}`;
    case "prompt":
      return `/prompts/${i.slug ?? i.entryId}`;
    case "ritual":
      return "/ritual";
    case "project":
      return "/projects";
  }
}

/**
 * Compact "freshly on the desk" strip: the three most recent changes.
 * Silent on loading/failure/empty — purely a returning-visitor signal.
 */
export function WhatsNewStrip() {
  const { data } = useAsync(() => client.whatsNew({ page: 1, pageSize: 3 }));
  const items = data?.items ?? [];
  if (items.length === 0) return null;

  return (
    <section className="whats-new-strip" aria-label="What's new">
      <div className="wrap">
        <p className="whats-new-strip-head">
          — freshly on the desk —{" "}
          <Link className="whats-new-strip-all" to="/whats-new">
            see everything →
          </Link>
        </p>
        <ul>
          {items.map((i) => (
            <li key={`${i.entryType}:${i.entryId}`}>
              <span className={`whats-new-change whats-new-change--${i.change}`}>
                {i.change}
              </span>
              <span className={`entry-badge entry-badge--${i.entryType}`}>{i.entryType}</span>
              <Link to={itemPath(i)}>{i.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
